import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.promise.finally.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../nls.js';
import { illegalArgument } from '../../base/common/errors.js';
import { URI } from '../../base/common/uri.js';
import { ICodeEditorService } from './services/codeEditorService.js';
import { Position } from '../common/core/position.js';
import { IModelService } from '../common/services/modelService.js';
import { ITextModelService } from '../common/services/resolverService.js';
import { MenuId, MenuRegistry } from '../../platform/actions/common/actions.js';
import { CommandsRegistry } from '../../platform/commands/common/commands.js';
import { ContextKeyExpr, IContextKeyService } from '../../platform/contextkey/common/contextkey.js';
import { KeybindingsRegistry } from '../../platform/keybinding/common/keybindingsRegistry.js';
import { Registry } from '../../platform/registry/common/platform.js';
import { ITelemetryService } from '../../platform/telemetry/common/telemetry.js';
import { withNullAsUndefined, assertType } from '../../base/common/types.js';
export var Command = /*#__PURE__*/function () {
  function Command(opts) {
    _classCallCheck(this, Command);

    this.id = opts.id;
    this.precondition = opts.precondition;
    this._kbOpts = opts.kbOpts;
    this._menuOpts = opts.menuOpts;
    this._description = opts.description;
  }

  _createClass(Command, [{
    key: "register",
    value: function register() {
      var _this = this;

      if (Array.isArray(this._menuOpts)) {
        this._menuOpts.forEach(this._registerMenuItem, this);
      } else if (this._menuOpts) {
        this._registerMenuItem(this._menuOpts);
      }

      if (this._kbOpts) {
        var kbWhen = this._kbOpts.kbExpr;

        if (this.precondition) {
          if (kbWhen) {
            kbWhen = ContextKeyExpr.and(kbWhen, this.precondition);
          } else {
            kbWhen = this.precondition;
          }
        }

        KeybindingsRegistry.registerCommandAndKeybindingRule({
          id: this.id,
          handler: function handler(accessor, args) {
            return _this.runCommand(accessor, args);
          },
          weight: this._kbOpts.weight,
          args: this._kbOpts.args,
          when: kbWhen,
          primary: this._kbOpts.primary,
          secondary: this._kbOpts.secondary,
          win: this._kbOpts.win,
          linux: this._kbOpts.linux,
          mac: this._kbOpts.mac,
          description: this._description
        });
      } else {
        CommandsRegistry.registerCommand({
          id: this.id,
          handler: function handler(accessor, args) {
            return _this.runCommand(accessor, args);
          },
          description: this._description
        });
      }
    }
  }, {
    key: "_registerMenuItem",
    value: function _registerMenuItem(item) {
      MenuRegistry.appendMenuItem(item.menuId, {
        group: item.group,
        command: {
          id: this.id,
          title: item.title,
          icon: item.icon // precondition: this.precondition

        },
        when: item.when,
        order: item.order
      });
    }
  }]);

  return Command;
}();
export var MultiCommand = /*#__PURE__*/function (_Command) {
  _inherits(MultiCommand, _Command);

  var _super = _createSuper(MultiCommand);

  function MultiCommand() {
    var _this2;

    _classCallCheck(this, MultiCommand);

    _this2 = _super.apply(this, arguments);
    _this2._implementations = [];
    return _this2;
  }
  /**
   * A higher priority gets to be looked at first
   */


  _createClass(MultiCommand, [{
    key: "addImplementation",
    value: function addImplementation(priority, implementation) {
      var _this3 = this;

      this._implementations.push([priority, implementation]);

      this._implementations.sort(function (a, b) {
        return b[0] - a[0];
      });

      return {
        dispose: function dispose() {
          for (var i = 0; i < _this3._implementations.length; i++) {
            if (_this3._implementations[i][1] === implementation) {
              _this3._implementations.splice(i, 1);

              return;
            }
          }
        }
      };
    }
  }, {
    key: "runCommand",
    value: function runCommand(accessor, args) {
      var _iterator = _createForOfIteratorHelper(this._implementations),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var impl = _step.value;

          if (impl[1](accessor, args)) {
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return MultiCommand;
}(Command); //#endregion

/**
 * A command that delegates to another command's implementation.
 *
 * This lets different commands be registered but share the same implementation
 */

export var ProxyCommand = /*#__PURE__*/function (_Command2) {
  _inherits(ProxyCommand, _Command2);

  var _super2 = _createSuper(ProxyCommand);

  function ProxyCommand(command, opts) {
    var _this4;

    _classCallCheck(this, ProxyCommand);

    _this4 = _super2.call(this, opts);
    _this4.command = command;
    return _this4;
  }

  _createClass(ProxyCommand, [{
    key: "runCommand",
    value: function runCommand(accessor, args) {
      return this.command.runCommand(accessor, args);
    }
  }]);

  return ProxyCommand;
}(Command);
export var EditorCommand = /*#__PURE__*/function (_Command3) {
  _inherits(EditorCommand, _Command3);

  var _super3 = _createSuper(EditorCommand);

  function EditorCommand() {
    _classCallCheck(this, EditorCommand);

    return _super3.apply(this, arguments);
  }

  _createClass(EditorCommand, [{
    key: "runCommand",
    value: function runCommand(accessor, args) {
      var _this5 = this;

      var codeEditorService = accessor.get(ICodeEditorService); // Find the editor with text focus or active

      var editor = codeEditorService.getFocusedCodeEditor() || codeEditorService.getActiveCodeEditor();

      if (!editor) {
        // well, at least we tried...
        return;
      }

      return editor.invokeWithinContext(function (editorAccessor) {
        var kbService = editorAccessor.get(IContextKeyService);

        if (!kbService.contextMatchesRules(withNullAsUndefined(_this5.precondition))) {
          // precondition does not hold
          return;
        }

        return _this5.runEditorCommand(editorAccessor, editor, args);
      });
    }
  }], [{
    key: "bindToContribution",
    value:
    /**
     * Create a command class that is bound to a certain editor contribution.
     */
    function bindToContribution(controllerGetter) {
      return /*#__PURE__*/function (_EditorCommand) {
        _inherits(EditorControllerCommandImpl, _EditorCommand);

        var _super4 = _createSuper(EditorControllerCommandImpl);

        function EditorControllerCommandImpl(opts) {
          var _this6;

          _classCallCheck(this, EditorControllerCommandImpl);

          _this6 = _super4.call(this, opts);
          _this6._callback = opts.handler;
          return _this6;
        }

        _createClass(EditorControllerCommandImpl, [{
          key: "runEditorCommand",
          value: function runEditorCommand(accessor, editor, args) {
            var controller = controllerGetter(editor);

            if (controller) {
              this._callback(controllerGetter(editor), args);
            }
          }
        }]);

        return EditorControllerCommandImpl;
      }(EditorCommand);
    }
  }]);

  return EditorCommand;
}(Command);
export var EditorAction = /*#__PURE__*/function (_EditorCommand2) {
  _inherits(EditorAction, _EditorCommand2);

  var _super5 = _createSuper(EditorAction);

  function EditorAction(opts) {
    var _this7;

    _classCallCheck(this, EditorAction);

    _this7 = _super5.call(this, EditorAction.convertOptions(opts));
    _this7.label = opts.label;
    _this7.alias = opts.alias;
    return _this7;
  }

  _createClass(EditorAction, [{
    key: "runEditorCommand",
    value: function runEditorCommand(accessor, editor, args) {
      this.reportTelemetry(accessor, editor);
      return this.run(accessor, editor, args || {});
    }
  }, {
    key: "reportTelemetry",
    value: function reportTelemetry(accessor, editor) {
      accessor.get(ITelemetryService).publicLog2('editorActionInvoked', {
        name: this.label,
        id: this.id
      });
    }
  }], [{
    key: "convertOptions",
    value: function convertOptions(opts) {
      var menuOpts;

      if (Array.isArray(opts.menuOpts)) {
        menuOpts = opts.menuOpts;
      } else if (opts.menuOpts) {
        menuOpts = [opts.menuOpts];
      } else {
        menuOpts = [];
      }

      function withDefaults(item) {
        if (!item.menuId) {
          item.menuId = MenuId.EditorContext;
        }

        if (!item.title) {
          item.title = opts.label;
        }

        item.when = ContextKeyExpr.and(opts.precondition, item.when);
        return item;
      }

      if (Array.isArray(opts.contextMenuOpts)) {
        var _menuOpts;

        (_menuOpts = menuOpts).push.apply(_menuOpts, _toConsumableArray(opts.contextMenuOpts.map(withDefaults)));
      } else if (opts.contextMenuOpts) {
        menuOpts.push(withDefaults(opts.contextMenuOpts));
      }

      opts.menuOpts = menuOpts;
      return opts;
    }
  }]);

  return EditorAction;
}(EditorCommand);
export var MultiEditorAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(MultiEditorAction, _EditorAction);

  var _super6 = _createSuper(MultiEditorAction);

  function MultiEditorAction(opts) {
    var _this8;

    _classCallCheck(this, MultiEditorAction);

    _this8 = _super6.call(this, opts);
    _this8._implementations = [];
    return _this8;
  }

  _createClass(MultiEditorAction, [{
    key: "runEditorCommand",
    value: function runEditorCommand(accessor, editor, args) {
      this.reportTelemetry(accessor, editor);

      var _iterator2 = _createForOfIteratorHelper(this._implementations),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var impl = _step2.value;

          if (impl[1](accessor, args)) {
            return;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return this.run(accessor, editor, args || {});
    }
  }]);

  return MultiEditorAction;
}(EditorAction); //#endregion
// --- Registration of commands and actions

export function registerLanguageCommand(id, handler) {
  CommandsRegistry.registerCommand(id, function (accessor, args) {
    return handler(accessor, args || {});
  });
}
export function registerDefaultLanguageCommand(id, handler) {
  registerLanguageCommand(id, function (accessor, args) {
    var resource = args.resource,
        position = args.position;

    if (!(resource instanceof URI)) {
      throw illegalArgument('resource');
    }

    if (!Position.isIPosition(position)) {
      throw illegalArgument('position');
    }

    var model = accessor.get(IModelService).getModel(resource);

    if (model) {
      var editorPosition = Position.lift(position);
      return handler(model, editorPosition, args);
    }

    return accessor.get(ITextModelService).createModelReference(resource).then(function (reference) {
      return new Promise(function (resolve, reject) {
        try {
          var result = handler(reference.object.textEditorModel, Position.lift(position), args);
          resolve(result);
        } catch (err) {
          reject(err);
        }
      }).finally(function () {
        reference.dispose();
      });
    });
  });
}
export function registerModelAndPositionCommand(id, handler) {
  CommandsRegistry.registerCommand(id, function (accessor) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var resource = args[0],
        position = args[1];
    assertType(URI.isUri(resource));
    assertType(Position.isIPosition(position));
    var model = accessor.get(IModelService).getModel(resource);

    if (model) {
      var editorPosition = Position.lift(position);
      return handler.apply(void 0, [model, editorPosition].concat(_toConsumableArray(args.slice(2))));
    }

    return accessor.get(ITextModelService).createModelReference(resource).then(function (reference) {
      return new Promise(function (resolve, reject) {
        try {
          var result = handler(reference.object.textEditorModel, Position.lift(position), args.slice(2));
          resolve(result);
        } catch (err) {
          reject(err);
        }
      }).finally(function () {
        reference.dispose();
      });
    });
  });
}
export function registerModelCommand(id, handler) {
  CommandsRegistry.registerCommand(id, function (accessor) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var resource = args[0];
    assertType(URI.isUri(resource));
    var model = accessor.get(IModelService).getModel(resource);

    if (model) {
      return handler.apply(void 0, [model].concat(_toConsumableArray(args.slice(1))));
    }

    return accessor.get(ITextModelService).createModelReference(resource).then(function (reference) {
      return new Promise(function (resolve, reject) {
        try {
          var result = handler(reference.object.textEditorModel, args.slice(1));
          resolve(result);
        } catch (err) {
          reject(err);
        }
      }).finally(function () {
        reference.dispose();
      });
    });
  });
}
export function registerEditorCommand(editorCommand) {
  EditorContributionRegistry.INSTANCE.registerEditorCommand(editorCommand);
  return editorCommand;
}
export function registerEditorAction(ctor) {
  var action = new ctor();
  EditorContributionRegistry.INSTANCE.registerEditorAction(action);
  return action;
}
export function registerMultiEditorAction(action) {
  EditorContributionRegistry.INSTANCE.registerEditorAction(action);
  return action;
}
export function registerInstantiatedEditorAction(editorAction) {
  EditorContributionRegistry.INSTANCE.registerEditorAction(editorAction);
}
export function registerEditorContribution(id, ctor) {
  EditorContributionRegistry.INSTANCE.registerEditorContribution(id, ctor);
}
export var EditorExtensionsRegistry;

(function (EditorExtensionsRegistry) {
  function getEditorCommand(commandId) {
    return EditorContributionRegistry.INSTANCE.getEditorCommand(commandId);
  }

  EditorExtensionsRegistry.getEditorCommand = getEditorCommand;

  function getEditorActions() {
    return EditorContributionRegistry.INSTANCE.getEditorActions();
  }

  EditorExtensionsRegistry.getEditorActions = getEditorActions;

  function getEditorContributions() {
    return EditorContributionRegistry.INSTANCE.getEditorContributions();
  }

  EditorExtensionsRegistry.getEditorContributions = getEditorContributions;

  function getSomeEditorContributions(ids) {
    return EditorContributionRegistry.INSTANCE.getEditorContributions().filter(function (c) {
      return ids.indexOf(c.id) >= 0;
    });
  }

  EditorExtensionsRegistry.getSomeEditorContributions = getSomeEditorContributions;

  function getDiffEditorContributions() {
    return EditorContributionRegistry.INSTANCE.getDiffEditorContributions();
  }

  EditorExtensionsRegistry.getDiffEditorContributions = getDiffEditorContributions;
})(EditorExtensionsRegistry || (EditorExtensionsRegistry = {})); // Editor extension points


var Extensions = {
  EditorCommonContributions: 'editor.contributions'
};

var EditorContributionRegistry = /*#__PURE__*/function () {
  function EditorContributionRegistry() {
    _classCallCheck(this, EditorContributionRegistry);

    this.editorContributions = [];
    this.diffEditorContributions = [];
    this.editorActions = [];
    this.editorCommands = Object.create(null);
  }

  _createClass(EditorContributionRegistry, [{
    key: "registerEditorContribution",
    value: function registerEditorContribution(id, ctor) {
      this.editorContributions.push({
        id: id,
        ctor: ctor
      });
    }
  }, {
    key: "getEditorContributions",
    value: function getEditorContributions() {
      return this.editorContributions.slice(0);
    }
  }, {
    key: "getDiffEditorContributions",
    value: function getDiffEditorContributions() {
      return this.diffEditorContributions.slice(0);
    }
  }, {
    key: "registerEditorAction",
    value: function registerEditorAction(action) {
      action.register();
      this.editorActions.push(action);
    }
  }, {
    key: "getEditorActions",
    value: function getEditorActions() {
      return this.editorActions.slice(0);
    }
  }, {
    key: "registerEditorCommand",
    value: function registerEditorCommand(editorCommand) {
      editorCommand.register();
      this.editorCommands[editorCommand.id] = editorCommand;
    }
  }, {
    key: "getEditorCommand",
    value: function getEditorCommand(commandId) {
      return this.editorCommands[commandId] || null;
    }
  }]);

  return EditorContributionRegistry;
}();

EditorContributionRegistry.INSTANCE = new EditorContributionRegistry();
Registry.add(Extensions.EditorCommonContributions, EditorContributionRegistry.INSTANCE);

function registerCommand(command) {
  command.register();
  return command;
}

export var UndoCommand = registerCommand(new MultiCommand({
  id: 'undo',
  precondition: undefined,
  kbOpts: {
    weight: 0
    /* EditorCore */
    ,
    primary: 2048
    /* CtrlCmd */
    | 56
    /* KEY_Z */

  },
  menuOpts: [{
    menuId: MenuId.MenubarEditMenu,
    group: '1_do',
    title: nls.localize({
      key: 'miUndo',
      comment: ['&& denotes a mnemonic']
    }, "&&Undo"),
    order: 1
  }, {
    menuId: MenuId.CommandPalette,
    group: '',
    title: nls.localize('undo', "Undo"),
    order: 1
  }]
}));
registerCommand(new ProxyCommand(UndoCommand, {
  id: 'default:undo',
  precondition: undefined
}));
export var RedoCommand = registerCommand(new MultiCommand({
  id: 'redo',
  precondition: undefined,
  kbOpts: {
    weight: 0
    /* EditorCore */
    ,
    primary: 2048
    /* CtrlCmd */
    | 55
    /* KEY_Y */
    ,
    secondary: [2048
    /* CtrlCmd */
    | 1024
    /* Shift */
    | 56
    /* KEY_Z */
    ],
    mac: {
      primary: 2048
      /* CtrlCmd */
      | 1024
      /* Shift */
      | 56
      /* KEY_Z */

    }
  },
  menuOpts: [{
    menuId: MenuId.MenubarEditMenu,
    group: '1_do',
    title: nls.localize({
      key: 'miRedo',
      comment: ['&& denotes a mnemonic']
    }, "&&Redo"),
    order: 2
  }, {
    menuId: MenuId.CommandPalette,
    group: '',
    title: nls.localize('redo', "Redo"),
    order: 1
  }]
}));
registerCommand(new ProxyCommand(RedoCommand, {
  id: 'default:redo',
  precondition: undefined
}));
export var SelectAllCommand = registerCommand(new MultiCommand({
  id: 'editor.action.selectAll',
  precondition: undefined,
  kbOpts: {
    weight: 0
    /* EditorCore */
    ,
    kbExpr: null,
    primary: 2048
    /* CtrlCmd */
    | 31
    /* KEY_A */

  },
  menuOpts: [{
    menuId: MenuId.MenubarSelectionMenu,
    group: '1_basic',
    title: nls.localize({
      key: 'miSelectAll',
      comment: ['&& denotes a mnemonic']
    }, "&&Select All"),
    order: 1
  }, {
    menuId: MenuId.CommandPalette,
    group: '',
    title: nls.localize('selectAll', "Select All"),
    order: 1
  }]
}));